import React, { Component } from 'react';
import MultiTestFormPageProps from './MultiTestFormPage.props';
import IMultiTestFormPageState from './MultiTestFormPage.state';
import MultiTestCustomerData from '../../components/MultiTestCustomerData/MultiTestCustomerData';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';

export default class MultiTestFormPage extends Component<MultiTestFormPageProps, IMultiTestFormPageState> {
    static contextType = GlobalContext;
    
    context!: React.ContextType<typeof GlobalContext>;

    constructor(props: MultiTestFormPageProps) {
        super(props);
        this.state = { 
            key: 'value',
        };
    }

    componentDidMount(): void {
        this.context.utilityProvider.dispatchEventReactAppInitialized();
    }

    render(): React.ReactNode {
        return (
            <section className="multi-test-form-page" data-testid="MultiTestFormPage">
                <div className="multi-test-form-page__wrapper">
                    <MultiTestCustomerData pageDetails={this.props.pageDetails} />
                </div>
            </section>
        )
    }
}
